/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Pain_WordsInputs */

const en_us2_search_field_pain_words = /** @type {(inputs: Search_Field_Pain_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pain hurt injury knee shoulder lower back spine wrist hip ankle elbow neck`)
};

const pt_br2_search_field_pain_words = /** @type {(inputs: Search_Field_Pain_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dor dores lesao machucado joelho ombro lombar coluna punho quadril tornozelo cotovelo pescoco`)
};

const es_419_search_field_pain_words = /** @type {(inputs: Search_Field_Pain_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dolor dolores lesion rodilla hombro lumbar espalda columna muneca cadera tobillo codo cuello`)
};

const pt_pt2_search_field_pain_words = /** @type {(inputs: Search_Field_Pain_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dor dores lesao magoado joelho ombro lombar coluna pulso anca tornozelo cotovelo pescoco`)
};

const fr_fr2_search_field_pain_words = /** @type {(inputs: Search_Field_Pain_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`douleur douleurs blessure mal genou epaule lombaires dos colonne poignet hanche cheville coude cou nuque`)
};

const de_de2_search_field_pain_words = /** @type {(inputs: Search_Field_Pain_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`schmerz schmerzen verletzung knie schulter rücken wirbelsäule handgelenk hüfte knöchel ellbogen nacken`)
};

const it_it2_search_field_pain_words = /** @type {(inputs: Search_Field_Pain_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dolore dolori infortunio lesione ginocchio spalla lombare schiena colonna polso anca caviglia gomito collo`)
};

/**
* | output |
* | --- |
* | "pain hurt injury knee shoulder lower back spine wrist hip ankle elbow neck" |
*
* @param {Search_Field_Pain_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_pain_words = /** @type {((inputs?: Search_Field_Pain_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Pain_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_pain_words(inputs)
	if (locale === "es-419") return es_419_search_field_pain_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_pain_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_pain_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_pain_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_pain_words(inputs)
	return en_us2_search_field_pain_words(inputs)
});
export { search_field_pain_words as "search.field_pain_words" }